var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 235,
    viewBox: "0 0 235 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.996 66.7045C122.536 57.901 111.812 50.4321 100.105 44.5786L95.7263 53.3366C106.486 58.7162 116.35 65.5661 125.067 73.6331L40.6 158.1C38.688 160.012 38.688 163.112 40.6 165.025C42.512 166.936 45.6118 166.936 47.5237 165.025L131.991 80.5569C140.057 89.2738 146.908 99.1385 152.287 109.898L161.045 105.518C155.191 93.8117 147.723 83.0882 138.92 73.6283L140.545 72.0033C142.456 70.0914 142.456 66.9915 140.545 65.0796C138.633 63.1676 135.533 63.1676 133.62 65.0796L131.996 66.7045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.667 132.188C143.148 132.188 132.188 143.147 132.188 156.667C132.188 170.186 143.148 181.146 156.667 181.146C170.187 181.146 181.146 170.186 181.146 156.667C181.146 143.147 170.187 132.188 156.667 132.188ZM122.396 156.667C122.396 137.74 137.74 122.396 156.667 122.396C175.595 122.396 190.938 137.74 190.938 156.667C190.938 175.594 175.595 190.938 156.667 190.938C137.74 190.938 122.396 175.594 122.396 156.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinero);
export default __webpack_public_path__ + "static/media/iconMinero.db4b138a144ace97d46f6439cfdcd084.svg";
export { ForwardRef as ReactComponent };